<template>
  <div class="uk-container">
    <h1>Manage {{viewBy | capitalize}} Members</h1>
    <div class="uk-button-group uk-align-right">
      <DashboardSearch v-on:search="setMembers" v-on:refresh="refreshSearch"/>
      
      <select class="uk-select" v-model="viewBy" v-on:change="changeView">
        <option value="active">View By: Active</option>
        <option value="booked">View By: Booked</option>
        <option value="refused">View By: Refused</option>
        <option value="absent">View By: Absent</option>
      </select>

      <vk-button type="primary" class="addMember" v-on:click="goToAddMember"><vk-icon icon="plus-circle"></vk-icon></vk-button>
    </div>
    <table class="uk-table">
      <thead>
        <th>#</th>
        <th>Notes</th>
        <th>Name</th>
        <th>Book #</th>
        <th>Phone Number</th>
        <th>Reg. Date</th>
        <th>Exp. Date</th>
        <th>Classes</th>
        <th>Certs</th>
        <th>Bookings</th>
        <th>Refusals</th>
        <th>Absences</th>
        <th>Remarks</th>
        <th>Actions</th>
      </thead>
      <tbody>
        <template v-for="(member, index) in members.slice((currentPage-1)*rowsPerPage, ((currentPage-1)*rowsPerPage+rowsPerPage))">
          <TableRow :member="member" :index="index+10*(currentPage-1)" v-on:refresh="refresh" v-bind:key="index"/>
        </template>
      </tbody>
    </table>
    <div class="pagination-buttons uk-pagination uk-flex-center">
      <span v-if="currentPage !== 1" >
        <a @click="currentPage-=1">&larr;</a>
      </span>
      <span v-for="(i,index) in pagination(currentPage, numPages)" v-bind:key="'nav-button-'+index">
        <a v-if="i !== '...'" @click="currentPage = i">{{i}}</a>
        <span v-else>...</span>
      </span>
      <span v-if="currentPage !== numPages" >
        <a @click="currentPage+=1">&rarr;</a>
      </span>
    </div>
  </div>
</template>

<script>
import MembersApi from "@/utils/api/members";
import TableRow from "./admin_queue_row.vue";
import DashboardSearch from "./admin_dashboard_search";

export default {
  name: "AdminDashboard",
  components: {
    TableRow,
    DashboardSearch
  },
  filters: {
    capitalize: function(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  },
  data() {
    return {
      loading: true,
      viewBy: "active",
      members: [],
      rowsPerPage: 10,
      numberRange: 2,
      currentPage: 1,
      numPages: 1
    };
  },
  created() {
    MembersApi.getMembers(this.$cookie.get("iwl_apiToken"))
      .then(members => {
        this.members = members;
        this.numPages = Math.ceil(members.length / this.rowsPerPage);
      })
      .catch(error => console.log(error));
  },
  methods: {
    goToAddMember() {
      this.$router.push("/administration/members/create");
    },
    refresh() {
      var path = "";
      switch (this.viewBy) {
        case "active":
          path = "";
          break;
        case "booked":
          path = "booked";
          break;
        case "refused":
          path = "refused";
          break;
        case "absent":
          path = "absent";
          break;
      }

      MembersApi.getMembers(this.$cookie.get("iwl_apiToken"), path)
        .then(members => {
          this.members = members;
          this.numPages = Math.ceil(members.length / this.rowsPerPage);
        })
        .catch(error => console.log(error));
    },
    refreshSearch() {
      var path = "";
      switch (this.viewBy) {
        case "active":
          path = "";
          break;
        case "booked":
          path = "booked";
          break;
        case "refused":
          path = "refused";
          break;
        case "absent":
          path = "absent";
          break;
      }

      MembersApi.getMembers(this.$cookie.get("iwl_apiToken"), path)
        .then(members => {
          this.currentPage = 1;
          this.members = members;
          this.numPages = Math.ceil(members.length / this.rowsPerPage);
        })
        .catch(error => console.log(error));
    },
    changeView() {
      var path = "";
      switch (this.viewBy) {
        case "active":
          path = "";
          break;
        case "booked":
          path = "booked";
          break;
        case "refused":
          path = "refused";
          break;
        case "absent":
          path = "absent";
          break;
      }

      MembersApi.getMembers(this.$cookie.get("iwl_apiToken"), path)
        .then(members => {
          this.members = members;
          this.numPages = Math.ceil(members.length / this.rowsPerPage);
        })
        .catch(error => console.log(error));
    },
    setMembers(newMembers) {
      this.members = newMembers;
      this.numPages = Math.ceil(newMembers.length / this.rowsPerPage);
    },
    pagination(currentPage, nrOfPages) {
      var delta = 2,
        range = [],
        rangeWithDots = [],
        l;

      range.push(1);

      if (nrOfPages <= 1) {
        return range;
      }

      for (let i = currentPage - delta; i <= currentPage + delta; i++) {
        if (i < nrOfPages && i > 1) {
          range.push(i);
        }
      }
      range.push(nrOfPages);

      for (let i of range) {
        if (l) {
          if (i - l === 2) {
            rangeWithDots.push(l + 1);
          } else if (i - l !== 1) {
            rangeWithDots.push("...");
          }
        }
        rangeWithDots.push(i);
        l = i;
      }

      return rangeWithDots;
    }
  }
};
</script>

<style scoped>
h1 {
  float: left;
  margin-bottom: 50px;
}
table {
  width: 100%;
  font-size: 13px;
}
.uk-select {
  width: auto;
}
.uk-button-group {
  margin-top: 6px;
}
.uk-button-group > .uk-button:nth-child(n + 2) {
  clear: both;
  margin-right: -4px;
  margin-left: -4px;
}
.uk-align-right div {
  display: inline-block;
}
.pagination-buttons {
  margin-top: 70px;
}
.pagination-buttons a {
  color: #1e87f0;
  font-size: 18px;
}
</style>


// WEBPACK FOOTER //
// src/components/admin_dashboard.vue